import { PaletteOptions } from '@mui/material';

const greenPalette: PaletteOptions = {
  primary: {
    25: '#F7FAF7',
    50: '#E7F0E7',
    100: '#A8C2B3',
    200: '#8FB29F',
    300: '#76A38B',
    400: '#5D967B',
    500: '#408B6B',
    600: '#0F6E4E',
    700: '#0E5841',
    800: '#1F4537',
    900: '#172922',
    main: '#0F6E4E',
  },
  secondary: {
    25: '#FFFAE5',
    50: '#FFF6CA',
    100: '#FFF1B0',
    200: '#FFED95',
    300: '#FEE87B',
    400: '#FEE360',
    500: '#FEDF46',
    600: '#FEDA2B',
    700: '#BFA320',
    800: '#7F6D16',
    900: '#40370B',
    main: '#FEDA2B',
  },
  error: {
    25: '#FEF0F0',
    50: '#FEE2E2',
    100: '#FED4D4',
    200: '#FEC6C6',
    300: '#FDB2B2',
    400: '#FB8C8C',
    500: '#FA6565',
    600: '#F93F3F',
    700: '#8C1D18',
    800: '#601410',
    900: '#410E0B',
  },
  neutral: {
    25: '#F8F8F8',
    50: '#F0F0F0',
    100: '#E1E1E1',
    200: '#D7D7D7',
    300: '#888888',
    400: '#707070',
    500: '#585858',
    600: '#4C4C4C',
    700: '#383838',
    800: '#2F2F2F',
    900: '#181818',
    A100: '#FFFFFF1A',
  },
  info: {
    100: '#ACFDE3',
    300: '#59FBC8',
    500: '#57E4B9',
    600: '#55CDA9',
    700: '#469F84',
    800: '#2e6852',
    main: '#2FFABA',
  },
  background: {
    default: '#383838',
    paper: '#383838',
  },
  text: {
    primary: '#fff',
    secondary: '#BCD6C8',
    disabled: '#6C867C',
  },
  promoPage: {
    heading: '#FFFFFF',
    description: '#CDE3D8',
    duration: '#FFF1B0',
    cardBackground: '#1B4638',
    buttonBorder: '#0B3024',
    buttonBackground: '#24634D',
    buttonBackgroundHover: '#328367',
    separator: '#5D967B66',
  },
} as const;

export default greenPalette;
